import React, { useContext, useMemo } from "react";
import Link from "../../utils/Link";
import Tilt from "react-tilt";
import { LanguageContext, text } from "../../container/language";
import { buildURLForCategory, buildURLForMenuItem } from "../../utils/buildURL";
import Features from "../Features";

const AccountListItem = (item) => {
  const { userLanguage } = useContext(LanguageContext);

  const { ref, parentCategory, blockMode } = item;
  const {
    cover,
    title,
    subtitle,
    excerpt,
    feature,
    main,
    description,
    button,
    slug,
  } = item.article || item.category || item;

  let url = "";

  if (blockMode) {
    url = buildURLForMenuItem(item);
  } else {
    url = `${buildURLForCategory(parentCategory)}/${slug}`;
  }

  return (
    <Tilt
      className="accounts-list__item"
      options={{
        max: 25,
        scale: 1,
        perspective: 2000,
        easing: "cubic-bezier(.03,.98,.52,.99)",
      }}
    >
      <div className="accounts-list__inner">
        <Link to={url} style={{ flexFlow: "row" }}>
          {cover && (
            <div className="accounts-list__preview">
              <img src={cover.url} alt={text(title, userLanguage)} />
            </div>
          )}
          <div className="accounts-list__text">
            <div className="accounts-list__title">
              <font>
                <font>{text(title, userLanguage)}</font>
              </font>
            </div>
            {excerpt && excerpt.text_sq && (
              <p>
                <font>
                  <font
                    dangerouslySetInnerHTML={{
                      __html: text(excerpt, userLanguage)
                        .split("\n")
                        .join("</br>"),
                    }}
                  ></font>
                </font>
              </p>
            )}
          </div>
        </Link>
      </div>
    </Tilt>
  );
};

export default AccountListItem;
